module.exports = __webpack_public_path__ + "static/media/voltarFeedback.18ef89b3.svg";